import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import Typography from "@material-ui/core/Typography";


const smallFont = {fontSize: 15};

export default function OptionDirection({optionDirection, setOptionDirection}) {
    return (
        <RadioGroup
            row
            aria-label="optionDirection"
            name="optionDirection"
            value={optionDirection}
            onChange={(ev) => {
                setOptionDirection(ev.target.value);
            }}
        >
            <Grid container>
                <Grid item xs={4}>
                    <FormLabel><Typography style={smallFont}>option direction:</Typography></FormLabel>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="buy to open" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>buy to open</Typography>}/>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="sell to open" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>sell to open</Typography>}/>
                </Grid>
            </Grid>
        </RadioGroup>
    );
}